export default "__VITE_PUBLIC_ASSET__74e9da43__"